"use client";

import React, { useEffect, useRef, useState } from "react";

import Image from "next/image";

import "./GalleryTaglineSection.css";

export default function GalleryTaglineSection({ projectDetail }) {
  const sectionRef = useRef(null);

  const [progress, setProgress] = useState(0);

  const [translate, setTranslate] = useState(120);

  const tagline = projectDetail?.gallery_data?.[0]?.tag_line;
  const vectorImages = {
    880: "/images/new-icons/project-vectors/palmVector.svg",
    881: "/images/new-icons/project-vectors/sarvamvector.svg",
    887: "/images/new-icons/project-vectors/parvavector.svg",
    888: "/images/new-icons/project-vectors/torrevector.svg",
  };

  const vectorImage = vectorImages[String(projectDetail?.project_id)];
  const isSarvam = projectDetail?.project_id == 881;
  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!sectionRef.current) return;

      if (ticking) return;

      ticking = true;

      requestAnimationFrame(() => {
        const rect = sectionRef.current.getBoundingClientRect();

        const vh = window.innerHeight;

        const isMobile = window.innerWidth < 768;

        /*
        responsive trigger points
        */

        const startPoint = isMobile ? vh * 0.75 : vh * 0.7;

        const endPoint = isMobile ? vh * 0.35 : vh * 0.12;

        const rawProgress =
          ((startPoint - rect.top) / (startPoint - endPoint)) * 100;

        const clamped = Math.max(0, Math.min(100, rawProgress));

        setProgress(clamped);

        /*
        less movement mobile
        */

        const maxMovement = isMobile ? 45 : 120;

        const movement = maxMovement - (clamped / 100) * maxMovement;

        setTranslate(movement);

        ticking = false;
      });
    };

    handleScroll();

    window.addEventListener("scroll", handleScroll, {
      passive: true,
    });

    window.addEventListener("resize", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);

      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  if (!tagline) return null;

  const words = tagline.split(" ");

  const firstLine = words.slice(0, Math.ceil(words.length / 2));

  const secondLine = words.slice(Math.ceil(words.length / 2));

  const isMobile =
    typeof window !== "undefined" ? window.innerWidth < 768 : false;

  return (
    <section ref={sectionRef} className="gallery-tagline-section">
      {vectorImage && (
        <div
          className={`gallery-watermark ${
            isSarvam ? "gallery-watermark-sarvam" : ""
          }`}
        >
          <Image
            src={vectorImage}
            alt="watermark"
            fill
            className="object-contain"
          />
        </div>
      )}

      <div className="main-container-fluid">
        <h2
          className="gallery-big-title"
          style={{
            "--fill": `${progress}%`,
          }}
        >
          <span
            style={{
              transform: `translate3d(-${translate}px,0,0)`,

              opacity: isMobile ? 0.7 + progress / 350 : 0.3 + progress / 140,
            }}
          >
            {firstLine.join(" ")}
          </span>

          <span
            style={{
              transform: `translate3d(${translate}px,0,0)`,

              opacity: isMobile ? 0.7 + progress / 350 : 0.3 + progress / 140,
            }}
          >
            {secondLine.join(" ")}
          </span>
        </h2>
      </div>
    </section>
  );
}
